module.exports = __webpack_public_path__ + "img/geeksalon.c895028d.png";